

export function WaterfallIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
      <svg {...props}
           viewBox="0 0 24 24"
           fill="none"
           xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              strokeWidth="currentStroke"
      >
          <path d="M21 21H3" strokeLinecap="round"/>
          <path d="M4 16V14" strokeLinecap="round"/>
          <path d="M12 12V9" strokeLinecap="round"/>
          <path d="M8 16V10" strokeLinecap="round"/>
          <path d="M16 13V11" strokeLinecap="round"/>
          <path d="M20 15V5" strokeLinecap="round"/>
      </svg>

  );
}